






























import { Select, Option } from 'element-ui';
import Vue from 'vue';

export default Vue.extend({
  name: 'HeaderTeipTable',
  components: {
    'el-select': Select,
    'el-option': Option,
  },
  props: {
    perPageOptions: {
      type: [Array, Object],
      default: true,
    },
    search: {
      type: Boolean,
      default: true,
    },
    perPage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      perPagePagination: 10,
      searchQuery: '',
    };
  },
  computed: {
    perPageOptionsSync: {
      get(): number[] {
        return this.perPageOptions;
      },
      set(val: number[]): void {
        this.$emit('update:perPageOptions', val);
      },
    },
    searchSync: {
      get(): boolean {
        return this.search;
      },
      set(val: boolean): void {
        this.$emit('update:search', val);
      },
    },
    perPageSync: {
      get(): number | boolean {
        return this.perPage;
      },
      set(val: number): void {
        this.$emit('update:perPage', val);
      },
    },
  },
  watch: {
    searchQuery(val: string) {
      this.$emit('input', val);
    },
    perPagePagination(page: number) {
      this.$emit('per-page', page);
    },
  },
});
